import React from "react";
import NavbarAuth from "components/navbar/NavbarAuth";
import Footer from "components/footer/FooterAuthCentered";
import Sidebar from "components/sidebar2";

const Centered = (props) => {
    const [open, setOpen] = React.useState(true);
    const {maincard} = props;
    return (
        <div className="flex min-h-screen w-full flex-col self-center justify-self-center overflow-hidden lg:mx-0">
            {/* <Sidebar variant="auth" open={open} onClose={() => setOpen(false)} />*/}
            {/*<NavbarAuth onOpenSidenav={() => setOpen(!open)} />*/}
            <div className="z-[1] mx-auto flex h-[80px] w-full max-w-screen-xl items-center justify-between px-3 xl:items-end">
                {/* horizon logo */}
                <a
                    className="leading-1 font-poppins text-[36px] font-bold text-white"
                >
                    Crompton <span className="font-bold text-[#004c86]"> SENZE</span>
                </a>
            </div>
            {/* <FixedPlugin /> */}
            <div
                className="absolute left-0 right-0 top-0 max-h-[48vh] min-h-[48vh] w-full overflow-hidden bg-gradient-to-br from-[#004c86] to[#004c86] and-600 bg-cover bg-no-repeat md:mx-auto"/>
            {/* bgImage={image} */}
            {maincard}
            <Footer/>
        </div>
    );
};

export default Centered;
